import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoutes from "./PrivateRoutes";
import SignIn from "../Auth";
import RegisterSimple from "../Components/Pages/Others/Authentication/RegisterSimple";
import CompanyRegistrationSimple from "../Components/Pages/Others/Authentication/CompanyRegistrationSimple";
import { Department } from "../Utils/Constants";
import DepartmentSimple from "../Components/Pages/Others/Authentication/DepartmentSimple";
import ForgotPassword from "../Auth/ResetPassword";
import ResetPassword from "../Auth/ResetPassword";
import RegisterEmployee from "../Components/Pages/Others/Authentication/RegisterEmployee";

export default function Routers() {
  const token = localStorage.getItem("token"); // Check JWT token instead of "login"

  return (
    <BrowserRouter basename={"/"}>
      <Routes>
        {/* Redirect if logged in */}
        {token ? (
          <Route path="/" element={<Navigate to="/dashboard/default" />} />
        ) : (
          <Route path="/" element={<Navigate to="/login" />} />
        )}

        {/* Protected Routes */}
        <Route element={<PrivateRoutes />}>
          <Route path="/*" element={<LayoutRoutes />} />
        </Route>

        {/* Public Routes */}
        <Route path="/login" element={<SignIn />} />
        <Route path="/register" element={<RegisterSimple />} />
        <Route path="/registeremployee" element={<RegisterEmployee />} />

        <Route
          path="/companyregister"
          element={<CompanyRegistrationSimple />}
        />
        <Route path="/departmentregister" element={<DepartmentSimple />} />
        <Route path="/resetpassword/:token" element={<ResetPassword />} />
      </Routes>
    </BrowserRouter>
  );
}
